import { app, DEVELOPMENT } from "../../../config/env";

export const apiUrl = (url) =>
  app.appEnv === DEVELOPMENT
    ? `https://local.industriousoffice.com${url}`
    : url;
